exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cover-388f85f1{width:100%;height:250px;background-position:top right;background-repeat:no-repeat;background-size:cover;position:relative;border-radius:5px}.header-065b01b0{position:absolute;display:flex;bottom:0;width:100%}.headerGradient-4645a57b{background:linear-gradient(-180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 100%);max-height:145px;height:50%;width:100%;position:absolute;bottom:0}.logo-d45d6eca{width:100px;height:100px;background-size:contain;border:1px solid #E0E0E0;flex:0 0 auto}.nameContainer-65cf7809{flex:1 0 auto;position:relative}.name-1b96a343{padding:0px 0px 10px 25px;bottom:0;left:0;color:#fff;position:absolute}.content-d5793cfb{padding:15px 20px 20px 20px}.dateLocation-f3c28e43 h4{display:flex;align-items:flex-end;margin-bottom:8px}.descIcon-c5623176{color:#616161;margin-right:0.5em}.hr-f9935a43.hr-f9935a43{border-top:2px solid #E0E0E0;margin:10px 0}.description-fa03a068{margin-bottom:20px}.editButton-7eee2185{max-width:200px}\n", ""]);

// Exports
exports.locals = {
	"cover": "cover-388f85f1",
	"header": "header-065b01b0",
	"headerGradient": "headerGradient-4645a57b",
	"logo": "logo-d45d6eca",
	"nameContainer": "nameContainer-65cf7809",
	"name": "name-1b96a343",
	"content": "content-d5793cfb",
	"dateLocation": "dateLocation-f3c28e43",
	"descIcon": "descIcon-c5623176",
	"hr": "hr-f9935a43",
	"description": "description-fa03a068",
	"editButton": "editButton-7eee2185"
};